module.exports = "/images/vendor/vue-piczoom/src/rotate.png?96e89d931c839abe54c5fbde045130fd";